module.exports = __webpack_public_path__ + "static/img/IE.4a3e438.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/IE.svg
// module id = 9sHu
// module chunks = 66